import { SymbolicTeamBreadcrumbs, SymbolicTeamForm } from 'modules/championship';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SymbolicTeam } from '../../../../domain/interfaces/symbolic-team';
import { selectSymbolicTeam } from '../../../../store/championship/actions';
import { championshipSymbolicTeamSelectedSelector } from '../../../../store/championship/selectors';
import { useAcceptedChampionshipTeams } from '../../../hooks/use-accepted-championship-teams';
import { SymbolicTeamsGrid } from './symbolic-teams-grid';

type ChampionshipSymbolicTeamsProps = {
  championshipId: number;
  items: SymbolicTeam[];
};

const ChampionshipSymbolicTeams = ({ championshipId, items }: ChampionshipSymbolicTeamsProps) => {
  const dispatch = useDispatch();
  const selectedSymbolicTeam = useSelector(championshipSymbolicTeamSelectedSelector(championshipId));
  const { teams: allTeams } = useAcceptedChampionshipTeams(championshipId);
  const [showForm, setShowForm] = useState<boolean>(false);

  const handleSelectTeam = useCallback(
    (team: SymbolicTeam | null) => {
      dispatch(selectSymbolicTeam({ symbolicTeam: team, championshipId }));
      setShowForm(true);
    },
    [dispatch, championshipId],
  );

  const handleShowList = useCallback(() => {
    dispatch(selectSymbolicTeam({ symbolicTeam: null, championshipId }));
    setShowForm(false);
  }, [dispatch, championshipId]);

  if (!showForm) {
    return (
      <div className="w-full px-6">
        <SymbolicTeamsGrid items={items} onSelect={handleSelectTeam} />
      </div>
    );
  }

  return (
    <div>
      <SymbolicTeamBreadcrumbs className="w-full px-6" activeTeamName={selectedSymbolicTeam?.name} onGoToListClick={handleShowList} />

      <div className="w-full px-6">
        <SymbolicTeamForm championshipId={championshipId} allTeams={allTeams!} symbolicTeam={selectedSymbolicTeam} />
      </div>
    </div>
  );
};

export default ChampionshipSymbolicTeams;
